import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaPinterest, FaYoutube, FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import { SiVisa, SiPaypal, SiGooglepay, SiApplepay } from 'react-icons/si';
import './Footer.css';

const Footer = () => {
  const footerLinks = {
    collections: ['Gold Collection', 'Silver Collection', 'Necklaces', 'Rings', 'Earrings', 'Bridal Sets'],
    information: ['About Us', 'Shipping Policy', 'Secure Payment', 'Contact Us', 'FAQs', 'Track Order'],
    legal: ['Terms & Conditions', 'Privacy Policy', 'Cookie Policy', 'Return Policy']
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="devnagari">श्री</span>PATI
            </div>
            <p className="brand-tagline">Luxury, Without the occasion. Crafted to Shine Everyday 💅</p>
            <p className="brand-desc">
              Premium quality imitation jewellery crafted with precision, 
              bringing luxury to every occasion. Experience the elegance of 
              श्रीPATI - where tradition meets modernity.
            </p>
            <div className="contact-info">
              <a href="tel:+919987072901" className="contact-link">
                <FaPhone /> +91 9987072901
              </a>
              <a href="mailto:riajain38388@gmail.com" className="contact-link">
                <FaEnvelope /> riajain38388@gmail.com
              </a>
            </div>
            <div className="social-icons">
              <a 
                href="https://www.instagram.com/shreepati__?igsh=NjhhNnp3cjZ6cDJx&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/share/1Jenz5EAVK/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a 
                href="https://in.pinterest.com/shreepati" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Pinterest"
              >
                <FaPinterest />
              </a>
              <a 
                href="https://www.youtube.com/@shreepati" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
              <a 
                href="https://wa.me/919987072901" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
          
          {Object.entries(footerLinks).map(([key, links]) => (
            <div key={key} className="footer-column">
              <h4 className="footer-title">{key.toUpperCase()}</h4>
              <ul>
                {links.map((link) => (
                  <li key={link}>
                    <Link to={`/shop?category=${link.toLowerCase().replace(' ', '-')}`}>
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <div className="payment-icons">
            <SiVisa size={30} />
            <SiPaypal size={30} />
            <SiGooglepay size={30} />
            <SiApplepay size={30} />
            <span className="payment-text">+ More</span>
          </div>
          <p className="copyright">
            © 2026 <span className="gold-text">श्रीPATI</span> · Luxury, Without the occasion. Crafted to Shine Everyday 💅
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;